import React from 'react';

const ReviewCard = ({ name, quote, rating, sourceLabel, sourceUrl }) => (
  <article className="card review-card">
    <div className="review-card-stars" aria-label={`${rating} out of 5 stars`}>
      {'★★★★★'}
    </div>
    <p className="review-card-quote">"{quote}"</p>
    <p className="review-card-name">{name}</p>
    <a
      className="review-card-source"
      href={sourceUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      {sourceLabel}
    </a>
  </article>
);

export default ReviewCard;
